export const DARK_MODE_STORAGE_KEY = 'darkMode';
export const ACCOUNT_ADDRESS_STORAGE_KEY = 'accountAddress';
export const WALLET_PROVIDER_STORAGE_KEY = 'walletProvider';
